import { useConsole } from "contexts/Console"
import styled from "@emotion/styled"
import { opaqueGreen, buttonFilled } from "css/buttons"
import { useDictionary } from "contexts/Dictionary"

const SkipLinksContainer = styled.div`
  position: absolute;
  display: flex;
  top: 90vh;
  left: 50%;
  transform: translateX(-50%);
  outline: none 0px;
  z-index: calc(var(--z-top, 10000) + 1);
`

const Link = styled.a`
  ${opaqueGreen}
  ${buttonFilled}
  opacity: 0;
  pointer-events: none;
  &:focus-within {
    pointer-events: auto;
    opacity: 1;
  }
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: calc(var(--z-top, 10000) + 1);
`

export default function Skip(props) {
  const console = useConsole()
  const dictionary = useDictionary()

  const onskiptofooter = e => {
    e.preventDefault()
    const target = document.documentElement
      .querySelector("footer")
      .querySelector(
        `input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), object:not([disabled]), a[href], area[href], iframe, embed,[tabindex]:not([tabindex^="-"]), [contenteditable]`
      )
    if (!target) return
    target.scrollIntoView({
      behavior: "instant",
      block: "start",
      inline: "start",
    })

    target.focus({ focusVisible: true })
  }

  const onskiptocontent = e => {
    e.preventDefault()
    const target = document.documentElement
      .querySelector("main")
      .querySelector(
        `input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), object:not([disabled]), a[href], area[href], iframe, embed,[tabindex]:not([tabindex^="-"]), [contenteditable]`
      )
    if (!target) return
    target.scrollIntoView({
      behavior: "instant",
      block: "start",
      inline: "start",
    })
    target.focus({ focusVisible: true })
  }

  const skiptoa11y = e => {
    e.preventDefault()
    const target = document.documentElement.querySelector("#a11y").querySelector("button:not([disabled])")
    if (!target) return
    target.scrollIntoView({
      behavior: "instant",
      block: "start",
      inline: "start",
    })
    target.focus({ focusVisible: true })
  }

  console.verbose("Header:skip(%o)", props)
  return (
    <SkipLinksContainer id='skipLinks' className={props.className ?? ""}>
      <Link id='skiptoa11y' onClick={skiptoa11y} aria-label={dictionary.skiptoa11y()} href='#a11y'>
        {dictionary.skiptoa11y()}
      </Link>
      <Link id='skiptocontent' onClick={onskiptocontent} aria-label={dictionary.skipToContent()} href='#main'>
        {dictionary.skipToContent()}
      </Link>
      {!props.nofooter && (
        <Link id='skiptofooter' onClick={onskiptofooter} aria-label={dictionary.skipToFooter()} href='#footer'>
          {dictionary.skipToFooter()}
        </Link>
      )}
    </SkipLinksContainer>
  )
}
